import { List, Map } from 'immutable'
import {
  Action,
  any,
  AsyncState,
  browserRouter,
  Fun,
  loadingAsyncState,
  none,
  nothing,
  Option,
  Pair,
  unloadedAsyncState,
  Widget,
  mk_pair,
  some,
  async,
  onlyIf,
  map,
  jsxToWidget,
  string,
  mk_widget,
  div,
  IOWidget
} from 'widgets-for-react'
import { Block } from '../wordpress/types_and_parser/standard_blocks.gen'
import { BlocksRenderer } from '../cms/blocks/block_to_widget.gen'
import { Breadcrumb } from '../wordpress/types_and_parser/extra_types.mod'
import {
  defaultPage,
  HeaderState,
  ContentType,
  emptyAppState,
  PublicSiteState,
  FooterState,
  OptionsState
} from '../public_site.main.mod'
import { EntryClient } from '../cms/widget.gen'
import { ExtraImages } from './utils/extra_images.mod'
import { Page } from '../cms/page/types.gen'
import { pageDisplay } from './blocks/renderer.mod'
import { PageStateZero } from '../cms/state/utils.gen'
import { PageTemplateState, AppState } from '../cms/state/types.gen'
import { ParsedNode } from '../wordpress/types_and_parser/types.ext.gen'
import { PublicSiteCustomRoutes, CustomPages } from './custom_pages/types.mod'
import { TransformStandardBlock, WordPressBlock_To_WidgetBlock } from '../wordpress/wordpress_to_cms.gen'
import { WordPress } from '../wordpress/wordpress_api'
import { WordPressBlockImagesLoader } from '../wordpress/rendering/image_utils.mod'
import { CustomBlock } from '../wordpress/types_and_parser/custom_blocks.mod'
import {
  downloadBlockClasses,
  mediaBlockClasses,
  quoteBlockClasses,
  iframeBlockClasses,
  textBlockClasses,
  expandBlockClasses,
  formBlockClasses,
  tableBlockClasses,
  ctaBlockClasses
} from './blocks/style.mod'
import { CustomBlockData } from './blocks/custom_blocks/types.mod'
import { history } from './templates/history.mod'
import { MediaBlockStyle } from './blocks/custom_blocks/widgets/mediaBlock'
import { QuoteBlockStyle } from './blocks/custom_blocks/widgets/quoteBlock'
import { DownloadBlockStyle } from '../cms/blocks/widgets/downloadBlock.gen'
import { ExtraParameters } from '../cms/router/type.gen'
import React from 'react'
import { dummyUpdates } from '../../styleguide/dummyContent'
import { CMSState } from '../cms/blocks/types.gen'
import { getFormState } from '../form/api'
import { GridBlockItem } from './blocks/custom_blocks/widgets/gridBlock.mod'
import { GridBlockItem2 } from './blocks/custom_blocks/widgets/gridBlock2.mod'
import { toRelativeUrl } from '../../helpers'
import { linkWrapper, isLinkExternal } from '../cms/blocks/utils.gen'
import { StringToHeaderType } from './blocks/custom_blocks/widgets/headerBlock.mod'
import { ImageGalleryBlockStyle } from './blocks/custom_blocks/widgets/imageGalleryBlock'
import { StepsBlockStyle } from './blocks/custom_blocks/widgets/stepsBlock'
import { createButtonData,unescapeHTML } from '../../utils'
import { Breadcrumbs } from './templates/breadcrumbs.mod'
import { Link } from 'react-router-dom'
import { TextBlockStyle } from './blocks/custom_blocks/widgets/textBlock'
import { LinkProps } from './blocks/custom_blocks/widgets/linkBlock'
import * as CountriesList from 'countries-list'
import { countries_list } from './templates/form_overview'

export const defaultLang: string = "nl";
export let lang: string = defaultLang;
export const availableLanguages = [
  { short: 'nl', full: 'Nederlands' },
  { short: 'en', full: 'English' }
]

export type PublicSite_CustomPageData = {
  posts: Map<number, AsyncState<WordPress.PostTypeResponse>>
  post: WordPress.PostTypeResponse
  news: WordPress.Overview
  vacancies: WordPress.Overview
  cases: WordPress.Overview
  extra_params?: ExtraParameters
}

const removeLangFromSlug = (slug, lang) => {
  if (slug) {
    var pathArray = slug.split('/');
    if (!pathArray[0]) pathArray.shift();
    if (pathArray[0] == lang && lang == "en") {
      lang = pathArray[0]
      pathArray.shift();
    }
    slug = `/${pathArray.join('/')}`
  }
  return slug
}

export const langToUrl = (lang) =>
  lang  == 'nl' ? '/' : `/${lang}`

const closeSearchAndMenu = s1 => (
  {
    ...s1,
    state: {
      ...s1.state,
      header: {
        ...s1.state.header,
        menu: 'closed',
        hoveredItem: null,
        showSearchBar: false
      }
    }
  }
)

export function asyncPost<PT>(id: number, lang: string): AsyncState<WordPress.PostTypeResponse> {
  return loadingAsyncState<WordPress.PostTypeResponse>(_ =>
    WordPress.api()
      .anypost(id)
      .then(response =>
        response.data ? { kind: 'result', status: 200, value: response.data } : { kind: 'failed', status: 404 }
      )
  )
}

export function asyncPosts(args?: WordPress.PostRequestArguments): AsyncState<Array<WordPress.PostTypeResponse>> {
  return loadingAsyncState<Array<WordPress.PostTypeResponse>>(_ =>
    WordPress.api<WordPress.PostTypeResponse>()
      .select('post')
      .where(args)
      .getMultiple()
      .then(response =>
        response.data
          ? { kind: 'result', status: 200, value: response.data }
          : {
            kind: 'failed',
            status: 404
          }
      )
  )
}

function loadExtraPostData(post: WordPress.PostTypeResponse): PublicSite_CustomPageData {
  let posts = Map<number, AsyncState<WordPress.PostTypeResponse>>()
  let news: WordPress.Overview;
  let cases: WordPress.Overview;
  let vacancies: WordPress.Overview

  if (post.type == 'page' && post.template == 'case-overview') {
    cases = {
      current_page: 0,
      async: loadingAsyncState<WordPress.OverviewResponse>(_ =>
        WordPress.api<WordPress.CaseResponse>()
          .select('case')
          .where({ per_page: 12 })
          .getMultiple()
          .then(response => response.data
            ? {
              kind: 'result', status: 200, value: {
                total_pages: response.headers["x-wp-totalpages"],
                total_articles: response.headers["x-wp-total"],
                kind: 'case',
                posts: response.data
              }
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      )
    }
  }

  if (post.type == 'page' && post.template == 'news-overview') {
    news = {
      current_page: 0,
      async: loadingAsyncState<WordPress.OverviewResponse>((_) =>
        WordPress.api<WordPress.NewsResponse>()
          .select('news')
          .where({ per_page: 13 })
          .getMultiple()
          .then((response) =>
            response.data
              ? {
                  kind: 'result',
                  status: 200,
                  value: {
                    total_pages: response.headers['x-wp-totalpages'],
                    total_articles: response.headers['x-wp-total'],
                    kind: 'news',
                    posts: response.data,
                  },
                }
              : {
                  kind: 'failed',
                  status: 404,
                }
          )
      ),
    }
  }

  if (post.type == 'page' && post.template == 'vacancy-overview') {
    vacancies = {
      current_page: 0,
      async: loadingAsyncState<WordPress.OverviewResponse>((_) =>
        WordPress.api<WordPress.VacancyResponse>()
          .select('vacancy')
          .where({ per_page: 12 })
          .getMultiple()
          .then((response) =>
            response.data
              ? {
                  kind: 'result',
                  status: 200,
                  value: {
                    total_pages: response.headers['x-wp-totalpages'],
                    total_articles: response.headers['x-wp-total'],
                    kind: 'vacancy',
                    posts: response.data,
                  },
                }
              : {
                  kind: 'failed',
                  status: 404,
                }
          )
      ),
    }
  }

  return {
    posts,
    post,
    cases,
    vacancies,
    news
  }
}

export const InitPagesStates: (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
) => PageTemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState> = b => ({
  page: PageStateZero<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState>(
    () => unloadedAsyncState(),
    defaultPage,
    pageDisplay(b)
  ).page
})

export const ERROR_PAGE_SLUG = '/not-found'

export const get_page = (
  slug: string,
  extra_parameters: ExtraParameters
): AsyncState<Page<CustomBlock, Block, PublicSite_CustomPageData>> =>
  loadingAsyncState(_ => {
    slug = removeLangFromSlug(slug, lang)
    return WordPress.api()
      .current(slug)
      .then(response => {
        // gtmPush({ event: 'event.aidence', category: 'Page', action: 'Loaded' })
        return response.data && response.data.acf
          ? {
            kind: 'result',
            value: {
              blocks: response.data.custom_blocks ? response.data.custom_blocks.map(b => TransformStandardBlock(b)) : [],
              extra_data: { ...loadExtraPostData(response.data), extra_params: extra_parameters }
            },
            status: 200
          }
          : { kind: 'failed', status: 404 }
      })
      .catch(e => {
        if (slug != ERROR_PAGE_SLUG) {
          return WordPress.api()
            .current(ERROR_PAGE_SLUG)
            .then(response => {
              return response.data && response.data.acf
                ? {
                  kind: 'result',
                  value: {
                    blocks: response.data.custom_blocks ? response.data.custom_blocks.map(b => TransformStandardBlock(b)) : [],
                    extra_data: { ...loadExtraPostData(response.data), extra_params: extra_parameters }
                  },
                  status: 200
                }
                : { kind: 'failed', status: 404 }
            })
            .catch(e2 => {
              console.error(e2)
              return e2
            })
        }
        else {
          console.error(e)
          return e
        }
      })
  })

export function get_options(id: string): AsyncState<WordPress.OptionsResponse> {
  return loadingAsyncState<WordPress.OptionsResponse>(_ =>
    WordPress.api()
      .options(id)
      .then(response => {
        return response.data
          ? { kind: 'result', status: 200, value: response.data }
          : {
            kind: 'failed',
            status: 404
          }
      })
  )
}

const getPost = (id: number) =>
  WordPress.api()
    .anypost(id)
    .then(response => {
      console.log('response', response)
      return response.data
        ? ({ kind: 'result', status: 200, value: response.data } as any)
        : {
          kind: 'failed',
          status: 404
        }
    })
    .catch(e => {
      console.log(e)
      return { kind: 'failed', status: 500 } as any
    })

export const application = (
  data: { rootpath: string; rootpath_to_ignore: string; login_address?: string },
  header: (_: HeaderState, o: OptionsState) => Widget<Action<HeaderState>>,
  footer: (
    _: AppState<PublicSiteState, PublicSiteCustomRoutes>
  ) => Widget<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>,
  errorPage: IOWidget<PublicSiteState, never>,
  loadingPage: Widget<never>,
  page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType>,
  custom_pages: CustomPages
) => {
  lang = window.wp.language;
  let rootpath = data.rootpath ? data.rootpath : ''
  let rootpath_to_ignore = data.rootpath_to_ignore ? data.rootpath_to_ignore : ''

  return (s0: AppState<PublicSiteState, PublicSiteCustomRoutes>) => {
    return browserRouter<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()(
      s0.route.kind == 'ignore'
        ? nothing()
        : any<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()([
          async<WordPress.OptionsResponse>(_ => nothing())(s0.state.options).map<
            Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
          >(a => s => {
            let s1 = a(s.state.options)

            return s1.kind == 'loaded'
              ? {
                ...s0,
                state: {
                  ...s0.state,
                  options: s1
                }
              }
              : s0
          }),

          s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'case-overview'
            ? async<WordPress.OverviewResponse>(_ => nothing())(s0.state.page.page.value.extra_data.cases.async).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          cases: {
                            ...s.state.page.page.value.extra_data.cases,
                            async: a(s.state.page.page.value.extra_data.cases.async)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),

          s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'news-overview'
            ? async<WordPress.OverviewResponse>(_ => nothing())(s0.state.page.page.value.extra_data.news.async).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          news: {
                            ...s.state.page.page.value.extra_data.news,
                            async: a(s.state.page.page.value.extra_data.news.async),
                          },
                        },
                      },
                    },
                  },
                },
              }
            })
            : nothing(),

          s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'vacancy-overview'
            ? async<WordPress.OverviewResponse>(_ => nothing())(s0.state.page.page.value.extra_data.vacancies.async).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          vacancies: {
                            ...s.state.page.page.value.extra_data.vacancies,
                            async: a(s.state.page.page.value.extra_data.vacancies.async),
                          },
                        },
                      },
                    },
                  },
                },
              }
            })
            : nothing(),

          any<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()(
            s0.state.page.page.kind == 'loaded'
              ? s0.state.page.page.value.extra_data.posts
                .map((p, key) =>
                  async<WordPress.PostTypeResponse>(_ => nothing())(p).map<
                    Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
                  >(a => s => {
                    if (s.state.page.page.kind != 'loaded') return s
                    let a1 = a(s.state.page.page.value.extra_data.posts.get(key))
                    return {
                      ...s,
                      state: {
                        ...s.state,
                        page: {
                          ...s.state.page,
                          page: {
                            ...s.state.page.page,
                            value: {
                              ...s.state.page.page.value,
                              extra_data: {
                                ...s.state.page.page.value.extra_data,
                                posts: s.state.page.page.value.extra_data.posts.set(key, a1)
                              }
                            }
                          }
                        }
                      }
                    }
                  })
                )
                .valueSeq()
                .toArray()
              : [nothing()]
          ),
          onlyIf(s0.route.kind != 'styleguide',
            header(s0.state.header, s0.state.options).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(
              a => s1 => ({
                ...s1,
                state: { ...s1.state, header: a(s1.state.header) }
              })
            )
          ),
          EntryClient<
            CustomBlockData,
            CustomBlock,
            Block,
            PublicSiteState,
            keyof CustomPages,
            PublicSiteCustomRoutes,
            ExtraImages,
            PublicSite_CustomPageData
          >({
            initState: emptyAppState(page),
            custom_pages,
            StandardBlockImagesLoader: WordPressBlockImagesLoader,
            StandardBlock_To_Widget: WordPressBlock_To_WidgetBlock,
            errorPage: errorPage,
            loadingPage: loadingPage,
            rootpath: rootpath,
            rootpath_to_ignore: rootpath_to_ignore,
            CustomBlock_To_Widget: (
              c: CustomBlock,
              block_index: number,
              extra_data: PublicSite_CustomPageData
            ): Option<CustomBlockData> => {
              if (c.kind == 'vidda/download') {
                const vidda_download: CustomBlockData = {
                  kind: 'downloadsBlock',
                  value: {
                    fst: {
                      index: block_index,
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      items: c.innerBlocks.map((downloadItem, index) => {
                        return {
                          key: index.toString(),
                          title: downloadItem.attrs.title,
                          text: downloadItem.attrs.file_name,
                          file_url: downloadItem.attrs.url
                        }
                      }),
                      useSVGIcons: false
                    },
                    snd: downloadBlockClasses as DownloadBlockStyle
                  }
                }
                return some(vidda_download)
              }

              if (c.kind == 'vidda/text') {
                const vidda_text: CustomBlockData = {
                  kind: 'textBlock',
                  value: {
                    fst: {
                      title: c.attrs.title,
                      text: c.attrs.text,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      has_show_more: c.attrs.has_show_more
                    },
                    snd: textBlockClasses as TextBlockStyle
                  }
                }

                return some(vidda_text)
              }

              if (c.kind == 'vidda/form') {
                let res = getFormState([], c.attrs.form_id)
                let lst = countries_list
                //we can implement here the mapping to translate the english names of the countries
                // let lst = []
                // for (let [key, value] of Object.entries(CountriesList.countries)) {
                //   lst.push(value.name)
                // }
                // lst = lst.sort()
                res.context.external_options = Map<string, string[]>().set("all_countries", lst)
                return some({
                  kind: 'formBlock',
                  value: {
                    fst: {
                      block_index: block_index,
                      form_id: c.attrs.form_id,
                      state: res
                    },
                    snd: formBlockClasses
                  }
                })
              }

              if (c.kind == 'vidda/table') {
                return some({
                  kind: 'tableBlock',
                  value: {
                    fst: {
                      block_index: block_index,
                      html: c.attrs.html
                    },
                    snd: tableBlockClasses
                  }
                })
              }

              if (c.kind == 'vidda/latest') {
                return some({
                  kind: 'latestBlock',
                  value: {
                    fst: {
                      title: c.attrs.title,
                      button: {
                        title: c.attrs.button_text,
                        url: '/updates'
                      },
                      hasBackground: c.attrs.hasBackground,
                      display:
                        c.attrs.variant == 'selected'
                          ? { kind: 'selected', ids: c.attrs.ids }
                          : { kind: 'latest' }
                    },
                    snd: {}
                  }
                })
              }

              if (c.kind == 'vidda/media') {
                const vidda_media: CustomBlockData = {
                  kind: 'mediaBlock',
                  value: {
                    fst: c.attrs.type == 'image' ? {
                      // image: c.attrs.type == 'video' ? null : c.attrs.image,
                      type: 'image',
                      // useCookieBar: false,
                      caption: c.attrs.caption,
                      image: c.attrs.image
                    } : {
                        type: 'video',
                        caption: (c.attrs.caption && c.attrs.caption.length != 0) ? c.attrs.caption : null,
                        // useCookieBar: true,
                        video: {
                          id: c.attrs.video.id,
                          url: c.attrs.video.url,
                          type: c.attrs.video.type,
                          frameBorder: c.attrs.video.frameBorder,
                          allowFullScreen: c.attrs.video.allowFullScreen
                        }
                      },
                    snd: mediaBlockClasses as MediaBlockStyle
                  }
                }
                return some(vidda_media)
              }

              if (c.kind == 'vidda/link-list') {
                const vidda_link_list: CustomBlockData = {
                  kind: 'linkListBlock',
                  value: {
                    fst: {
                      index: null,
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      items: c.innerBlocks.map((linkItem, index) => {
                        let link = linkWrapper({ title: linkItem.attrs.link_text, url: linkItem.attrs.link_url })
                        return {
                          key: index.toString(),
                          title: link.title,
                          url: link.url,
                          is_link_external: link.is_link_external
                        } as LinkProps
                      }),
                      useSVGIcons: false,
                    },
                    snd: null
                  }
                }
                return some(vidda_link_list)
              }

              if (c.kind == 'vidda/expandable') {
                const vidda_expandable: CustomBlockData = {
                  kind: 'expandableBlock',
                  value: {
                    fst: {
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      link: c.attrs.show_button && c.attrs.button_url && c.attrs.button_text ? linkWrapper({ title: c.attrs.button_text, url: c.attrs.button_url }) : null,
                      index: block_index,
                      items: c.innerBlocks.map((expandableItem, index) => {
                        return {
                          index: index,
                          key: index.toString(),
                          title: expandableItem.attrs.title,
                          open: false,
                          useSVGIcons: false,
                          blocks: expandableItem.innerBlocks.map(innerBlock => innerBlock.innerHTML)
                        }
                      })
                    },
                    snd: null
                  }
                }

                return some(vidda_expandable)
              }

              if (c.kind == 'vidda/quote') {
                const vidda_quote: CustomBlockData = {
                  kind: 'customQuoteBlock',
                  value: {
                    fst: {
                      index: block_index,
                      text: c.attrs.text,
                      author: c.attrs.author,
                      company: c.attrs.company,
                      primary_button: c.attrs.primary_button_text && c.attrs.primary_button_url
                        ? linkWrapper({ title: c.attrs.primary_button_text, url: c.attrs.primary_button_url })
                        : null,
                      secondary_button: c.attrs.secondary_button_text && c.attrs.secondary_button_url
                        ? linkWrapper({ title: c.attrs.secondary_button_text, url: c.attrs.secondary_button_url })
                        : null
                    },
                    snd: quoteBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_quote)
              }

              if (c.kind == 'vidda/iframe') {
                return some({
                  kind: 'iframeBlock',
                  value: {
                    fst: {
                      index: block_index,
                      link: c.attrs.url
                    },
                    snd: iframeBlockClasses
                  }
                } as CustomBlockData)
              }

              if (c.kind == 'vidda/header') {
                const vidda_header: CustomBlockData = {
                  kind: 'headerBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/header',
                      header_type: StringToHeaderType(c.attrs.header_type),
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      image: c.attrs.image,
                      image_mobile: c.attrs.image_mobile,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_header)
              }

              if (c.kind == 'vidda/image-text') {
                const vidda_image_text: CustomBlockData = {
                  kind: 'imageTextBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/image-text',
                      image_position: c.attrs.image_position,
                      image: c.attrs.image,
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      background_color: c.attrs.background_color ? c.attrs.background_color : 'dark'
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_image_text)
              }

              if (c.kind == 'vidda/grid' || c.kind == 'vidda/grid-with-image') {
                const vidda_grid: CustomBlockData = {
                  kind: 'gridBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/grid',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      blocks: c.innerBlocks.map(innerBlock => {
                        return {
                          title: innerBlock.attrs.title,
                          intro: innerBlock.attrs.intro,
                          image: innerBlock.attrs.image,
                          icon: innerBlock.attrs.icon,
                          link: innerBlock.attrs.link_url
                            ? linkWrapper({ title: innerBlock.attrs.link_text, url: innerBlock.attrs.link_url })
                            : undefined,
                        } as GridBlockItem
                      })
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_grid)
              }

              if (c.kind == 'vidda/grid-with-image2') {
                const vidda_grid: CustomBlockData = {
                  kind: 'gridBlock2',
                  value: {
                    fst: {
                      blockName: 'vidda/grid2',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                      blocks: c.innerBlocks.map(innerBlock => {
                        return {
                          title: innerBlock.attrs.title,
                          intro: innerBlock.attrs.intro?.replace(/\n/g, "<br>"),
                          image: innerBlock.attrs.image,
                          has_email_link: innerBlock.attrs.has_email_link,
                          has_tel_link: innerBlock.attrs.has_email_link,
                          email_link_text: innerBlock.attrs.email_link_text,
                          email_link_url: innerBlock.attrs.email_link_url,
                          tel_link_text: innerBlock.attrs.tel_link_text,
                          tel_link_url: innerBlock.attrs.tel_link_url
                        } as GridBlockItem2
                      })
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_grid)
              }



              if (c.kind == 'vidda/facts-and-figures') {
                const vidda_facts_and_figures: CustomBlockData = {
                  kind: 'factsAndFiguresBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/facts-and-figures',
                      items: c.innerBlocks.map(item => { return { amount: item.attrs.amount, label: item.attrs.label, intro: item.attrs.intro } })
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_facts_and_figures)
              }
              if (c.kind == 'vidda/cta') {
                const vidda_cta: CustomBlockData = {
                  kind: 'ctaBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/cta',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                    },
                    snd: ctaBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_cta)
              }

              if (c.kind == 'vidda/image-stack') {
                const vidda_image_stack: CustomBlockData = {
                  kind: 'imageStackBlock',
                  value: {
                    fst: {
                      block_index: block_index,
                      blockName: 'vidda/image-stack',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      items: c.innerBlocks.map(imageBlock => { return { image: imageBlock.attrs.image, caption: imageBlock.attrs.caption } })
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_image_stack)
              }

              if (c.kind == 'vidda/attention') {
                const vidda_image_stack: CustomBlockData = {
                  kind: 'attentionBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/attention',
                      title: c.attrs.title,
                      image: c.attrs.image
                    },
                    snd: textBlockClasses as QuoteBlockStyle
                  }
                }

                return some(vidda_image_stack)
              }

              if (c.kind == 'vidda/gallery') {
                const vidda_image_gallery: CustomBlockData = {
                  kind: 'imageGalleryBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/gallery',
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      items: c.innerBlocks.map(imageBlock => { return { image: imageBlock.attrs.image, caption: imageBlock.attrs.caption } })
                    },
                    snd: textBlockClasses as ImageGalleryBlockStyle
                  }
                }

                return some(vidda_image_gallery)
              }

              if (c.kind == 'vidda/featured-content') {
                const vidda_featured_content: CustomBlockData = {
                  kind: 'featuredContentBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/featured-content',
                      label: c.attrs.label,
                      title: c.attrs.title,
                      intro: c.attrs.intro,
                      button: c.attrs.show_button && c.attrs.button_url && c.attrs.button_text ? createButtonData(c.attrs.button_text, c.attrs.button_url) : null,
                      image_position: c.attrs.image_position,
                      image: c.attrs.image
                    },
                    snd: null
                  }
                }

                return some(vidda_featured_content)

              }
              if (c.kind == 'vidda/steps') {
                const vidda_steps_block: CustomBlockData = {
                  kind: 'stepsBlock',
                  value: {
                    fst: {
                      blockName: 'vidda/steps',
                      index: block_index,
                      image: c.attrs.image,
                      title: c.attrs.title,
                      blocks: c.innerBlocks.map(innerBlock => {
                        return {
                          attrs: {
                            title: innerBlock.attrs.title,
                            text: innerBlock.attrs.content
                          }
                        }
                      }),
                      primary_button: c.attrs.show_primary_button ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
                      secondary_button: c.attrs.show_secondary_button ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
                    },
                    snd: textBlockClasses as StepsBlockStyle
                  }
                }

                return some(vidda_steps_block)
              }

              return none()
            },
            CustomBLockImagesLoader: (c: CustomBlock) => {
              // if (c.kind == 'exampleBlock') {
              //   //let img = mk_pair(c.image, loadMedia(c.image) as AsyncState<Map<ImageSize<ExtraImages>, Url>>)
              //   //improve when personBlock is ready in drupal/parsed_types
              //   return []
              // }
              return []
            }
          })(s0),
          // s0.state.latest_updates.kind == 'loaded' ?
          //   LatestBlock(
          //     {
          //       title: 'Laatste updates',
          //       button: {
          //         title: 'Bekijk alle updates',
          //         url: '/updates'
          //       },
          //       hasBackground: false,
          //       display: { kind: 'latest' }
          //     },
          //     { style: {} }
          //   )({} as CMSState<{}, {}, never>)

          //   latestUpdates(s0.state.latest_updates).never()
          // : nothing(),
          onlyIf(s0.route.kind != 'styleguide',
            footer(s0).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(a => s1 => a(s1)),
          ),
          history().map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(la => {
            la.action == 'PUSH' && window.scrollTo(0, 0)
            return closeSearchAndMenu
          }),
        ])
    ).map<AppState<PublicSiteState, PublicSiteCustomRoutes>>(a => {
      let s1 = a(s0)

      if (s0.route != s1.route) {
        s1 = closeSearchAndMenu(s1)
      }

      if( s1.state.page.page.kind == "loaded" && s0.state.page.page.kind != "loaded") {
        s1.state.page.display = page(mk_pair(List(), some(s1.state.page.page.value.extra_data.post)))
      }

      if (
        s1.state.page.page.kind == 'loaded' &&
        s1.state.page.page.value.extra_data.post.yoast &&
        s1.state.page.page.value.extra_data.post.yoast.title
      ) {
        document.title = unescapeHTML(s1.state.page.page.value.extra_data.post.yoast.title)
      }

      s1.state.header.menu == 'open' ?
        document.documentElement.classList.add('menu--open')
      : document.documentElement.classList.remove('menu--open')

      if (s1.state.header.menu == 'open' || s1.state.header.showSearchBar) {
        document.body.setAttribute('data-scroll', 'locked')
      } else {
        document.body.setAttribute('data-scroll', '')
      }

      if(s1.route != s0.route){
        document.getElementsByClassName("header")[0].scrollIntoView()
      }

      return s1
    })
  }
}
